import Menu from 'antd/es/menu';
import styled from 'styled-components';
import { TMenuItem } from './MenuItem.types';

const { Item, SubMenu } = Menu;
export const SMenuItem = styled(Item)<TMenuItem>`
  pointer-events: ${props => props.unselectable === 'on' && 'none'};
`;

export const SSubMenu = styled(SubMenu)``;
